angular
	.module 'App.Repository'

.factory 'PublicRepository', ['BaseRepository', (BaseRepository) ->
	class PublicRepository extends BaseRepository
		@resource = '/public'
		@isRestricted = false

		getCountries: (query) ->
			@findByQuery query, '/countries'

		getLanguages: (query) ->
			@findByQuery query, '/languages'

		getTranslatedLanguages: (query) ->
			@findByQuery query, '/languages/translated'
				.then (response) ->
					return response.data
				.catch ->
					return []

		getDocumentationUrl: ->
			@getUrl '/readme/open_api'

		signUp: (data) ->
			@post 'sign_up', data

		validatePasswordToken: (token) ->
			@post('validate_password_token', {token: token})
				.then (response) => response.data.status == true

		resetPassword: (data) ->
			@post('reset_password', data)
				.then (response) => response.data

		requestResetPassword: (email, identifier = null) ->
			@post('request_reset_password', {email: email, identifier: identifier})
				.then (response) => response.data

		unsubscribeGiftcard: (giftcardId, token) ->
			return @post("giftcard/#{giftcardId}/unsubscribe", {token: token})

	return new PublicRepository
]
